import * as React from 'react';
import { UIText2, Chips, TOptionValue, IChipsOption } from '@cian/ui-kit';

import { ERooms } from '../../types/filters';
import * as styles from './CheckboxGroup.css';

interface IRoomsCheckboxProps {
  title: string;
  value: TOptionValue[];
  options: IChipsOption<ERooms>[];
  onChange: (value: TOptionValue[]) => void;
  testId?: string;
}

export function CheckboxGroup({ title, value, options, testId, onChange }: IRoomsCheckboxProps) {
  return (
    <>
      <UIText2>{title}</UIText2>
      <div className={styles['group']} data-testid={testId}>
        <Chips size="S" inline selectType="multiple" options={options} value={value} onChange={onChange} />
      </div>
    </>
  );
}
